import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import moment from "moment"

import {
  Grid,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  CardHeader,
} from "@material-ui/core"

import styles from "./page-list.module.scss"

function PageList() {
  const {
    allMdx: { nodes },
    allFile: { nodes: imageFiles },
  } = useStaticQuery(
    graphql`
      query {
        allMdx(sort: { fields: frontmatter___date, order: DESC }) {
          nodes {
            frontmatter {
              date
              title
              image
            }
            slug
            excerpt
          }
        }
        allFile(filter: { ext: { in: [".png", ".jpg"] } }) {
          nodes {
            relativePath
            childImageSharp {
              fixed {
                src
              }
            }
            ext
          }
        }
      }
    `
  )

  return (
    <Grid container spacing={5} direction="row" justify="center">
      {nodes.slice(0, 10).map(node => {
        const { frontmatter: it, slug, excerpt } = node
        const img = imageFiles.find(file => file.relativePath === it.image)
        return (
          <Grid item>
            <Link style={{ textDecoration: "none" }} to={`/${slug}`}>
              <Card className={styles.flexItem}>
                <CardMedia
                  className={styles.itemMedia}
                  image={img.childImageSharp.fixed.src}
                  title={it.title}
                />

                <CardContent>
                  <Typography variant="h5" component="h2">
                    {it.title}
                  </Typography>
                  <Typography gutterBottom variant="caption" component="h5">
                    {moment
                      .duration(moment(it.date).diff(moment()))
                      .humanize(true)}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    {excerpt.replace(it.title, "")}
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default PageList
